"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRecipeToSectionMutationOptions = exports.addRecipeToSectionMutation = void 0;
const client_1 = require("@apollo/client");
const updateQuery_1 = require("../../../utils/updateQuery");
const recipesByCookbookAndSectionId_1 = require("../../recipe/queries/recipesByCookbookAndSectionId");
exports.addRecipeToSectionMutation = client_1.gql `
  mutation AddRecipeToSection($recipeId: String!, $sectionId: String!) {
    addRecipeToSection(recipeId: $recipeId, sectionId: $sectionId) {
      __typename
      ok
    }
  }
`;
exports.addRecipeToSectionMutationOptions = (variables, recipe, destination) => ({
    variables,
    update: store => {
        let data = null;
        try {
            data = store.readQuery({
                query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                variables: { sectionId: variables.sectionId },
            });
        }
        catch (_a) { }
        if (data) {
            store.writeQuery({
                query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                variables: { sectionId: variables.sectionId },
                data: {
                    __typename: "Query",
                    recipesByCookbookAndSectionId: [
                        ...data.recipesByCookbookAndSectionId,
                        recipe,
                    ],
                },
            });
        }
        updateQuery_1.updateFragment(store, `Recipe:${variables.recipeId}`, `
            cookbookSectionLookup {
              cookbook {
                id
                name
                accessLevel
              }
              section {
                id
                name
              }
            }
    `, x => {
            if (x.cookbookSectionLookup) {
                x.cookbookSectionLookup.push(destination);
            }
        });
    },
});
//# sourceMappingURL=addRecipeToSection.js.map